import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import * as constants from '@/constants';
import ApiService from '@/common/api.service';

export default {
	getBaseUrl() {
		let host = constants.GUEST_AUTHENTICATION_HOST();
		return host;
	},
	getEndpoint(endpoint) {
		let host = this.getBaseUrl();
		return host + '/' + endpoint;
	},
	getAuthenticationZoneByLocation(location_id, zone_id, ssid) {
		let endpoint = this.getEndpoint(`authentication_zone_by_location?location_id=${location_id}&zone_id=${zone_id}&ssid=${ssid}`);
		return ApiService.query(endpoint);
	}
}